import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getDepositOptions } from 'store/actions/offerActions'

const useGetProjectDepositOptions = () => {
  // @ts-ignore
  const appProject = useSelector((state) => state.appReducer.appProject)

  const [depositOptions, setDepositOptions] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getData()
  }, [appProject])

  const getData = async () => {
    setLoading(true)
    try {
      const data = await getDepositOptions(appProject)
      setDepositOptions(data ?? [])
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }

  return { loading, depositOptions }
}

export default useGetProjectDepositOptions
